import { useState } from "react";
import { Modal, Button } from "antd";
import { unblockUser } from "../../utils/users";
import { useAuth0 } from "@auth0/auth0-react";
import { useSnackbar } from "notistack";

const UserUnblockModal = ({ id, showModal, onClose, onSuccess }) => {
  const { getIdTokenClaims } = useAuth0();
  const { enqueueSnackbar } = useSnackbar();
  const [submitting, setSubmitting] = useState(false);

  const handleUnblockUser = () => {
    setSubmitting(true);

    (async () => {
      try {
        const token = await getIdTokenClaims();

        unblockUser(token.__raw, id)
          .then((res) => {
            if (!res.data.success) {
              console.log("Unblocking user failed");
              enqueueSnackbar(res.data.message || "Failed to unblock user", {
                variant: "error",
              });
            } else {
              enqueueSnackbar(
                res.data.message || "User has been unblocked successfully",
                {
                  variant: "success",
                }
              );
              onSuccess();
              onClose();
            }
          })
          .catch((err) => {
            console.error(err);
            enqueueSnackbar(
              "Something went wrong. Please contact support.",
              {
                variant: "error",
              }
            );
          })
          .finally(() => {
            setSubmitting(false);
          });
      } catch (e) {
        console.error(e);
        setSubmitting(false);
      }
    })();
  };

  const handleClose = () => {
    setSubmitting(false);
    onClose();
  };

  return (
    <Modal
      title={[<div className={"text-2xl"}>Unblock User</div>]}
      centered
      open={showModal}
      destroyOnClose={true}
      footer={[
        <div className={"flex items-center justify-end gap-3"}>
          <Button
            key="cancel"
            className={"px-2 text-sm py-1.5 border border-gray-200 rounded-lg"}
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            key="submit"
            className={"px-2 text-sm py-1.5"}
            onClick={() => {
              handleUnblockUser();
            }}
            loading={submitting}
          >
            Unblock User
          </Button>
        </div>,
      ]}
      onCancel={handleClose}
    >
      <div className={"py-8 text-gray-500 text-sm border-b border-gray-300"}>
        <p>
          Are you sure you want to unblock this user? They will regain access
          to the system.
        </p>
      </div>
    </Modal>
  );
};

export default UserUnblockModal;
